import { CommonModule } from '@angular/common';
import { SharedChartsModule } from '@realize-reports/shared-charts';
import { defineCustomElements } from '@savvaslearning/cel-components/dist-stencil/loader';
import { CoreModule } from '../core/core.module';
import { ApolloService } from '../core/services/apollo-service/apollo.service';
import { SharedModule } from '../shared/shared.module';
import { ActiveStudentsPerWeekComponent } from './active-students-per-week/active-students-per-week.component';
import { ActiveTeachersPerWeekComponent } from './active-teachers-per-week/active-teachers-per-week.component';
import { EngagementBySchoolsComponent } from './engagement-by-schools/engagement-by-schools.component';
import { RealizeOverviewRoutingModule } from './realize-overview-routing.module';
import { RealizeOverviewComponent } from './realize-overview.component';
import { RealizeOverviewDataService } from './services/realize-overview-data/realize-overview-data.service';
import { RealizeOverviewService } from './services/realize-overview/realize-overview.service';
import { StandardsPerformanceByProgramsComponent } from './standards-performance-by-programs/standards-performance-by-programs.component';
import { LastExecutedTimeComponent } from './last-executed-time/last-executed-time.component';
import * as i0 from "@angular/core";
defineCustomElements(window, {
    transformTagName: (tagName) => `realize-reports-overview-${tagName}`,
});
export class RealizeOverviewModule {
}
RealizeOverviewModule.ɵfac = function RealizeOverviewModule_Factory(t) { return new (t || RealizeOverviewModule)(); };
RealizeOverviewModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: RealizeOverviewModule });
RealizeOverviewModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [RealizeOverviewDataService, RealizeOverviewService, ApolloService], imports: [[CommonModule, RealizeOverviewRoutingModule, CoreModule, SharedChartsModule, SharedModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(RealizeOverviewModule, { declarations: [RealizeOverviewComponent,
        ActiveStudentsPerWeekComponent,
        ActiveTeachersPerWeekComponent,
        EngagementBySchoolsComponent,
        StandardsPerformanceByProgramsComponent,
        LastExecutedTimeComponent], imports: [CommonModule, RealizeOverviewRoutingModule, CoreModule, SharedChartsModule, SharedModule], exports: [RealizeOverviewComponent] }); })();
